export default defineAppConfig({
  ui: {
    primary: 'blue',
    gray: 'neutral'
  },
  nuxtIcon: {}
})
